export default "__VITE_ASSET__CrZXd412__"